import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const wholeTokenFromCookie = JSON.parse(getCookieByName(sharedCookieKey));

        let spatFromCookie = wholeTokenFromCookie.spat;
        /* NOTE this is different than in CT, as the payload is constructed in the template as one string rather than
        combined here.  Decided to split this off from CT to reduce potential breaking/conflicts.
         */

        //? for debug: console.log( "MRBEnterTicket payload", payload );
        let checkResult = await apiClient(config).apiMethod({
            method: 'MRBEnterTicket',
            headers: {
                'X-Auth-Token': jwtFromCookie,
                'X-Auth-Spat': spatFromCookie,
            },
            args: {
                ...payload,
            },
        });

        const processCheckResult = (checkResult) => {
            if (!checkResult) {
                return {
                    success: false,
                    message: '_UNKNOWN',
                };
            }

            if (checkResult.code) {
                if (checkResult.code === '_SUCCESS') {
                    return {
                        entry: checkResult,
                        success: true,
                        message: 'success',
                    };
                }
                return {
                    success: false,
                    message: checkResult.code,
                };
            }

            return {
                entry: checkResult,
                success: true,
                message: 'success',
            };
        };

        return processCheckResult(checkResult);
    };
};
